import { Card, CardContent } from "../../../components/ui/Card";
import { Badge } from "../../../components/ui/Badge";
import { Clock, Eye } from "lucide-react";

const ArticleCard = ({ title, excerpt, category, readTime, views, tags = [] }) => {
  return (
    <Card className="group cursor-pointer transition-smooth hover:shadow-lg hover:border-primary/30">
      <CardContent className="p-6">
        <div className="space-y-3">
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <Badge variant="outline" className="text-primary border-primary/30">
              {category}
            </Badge>
            <span className="flex items-center gap-1">
              <Clock className="h-3 w-3" />
              {readTime}
            </span>
            <span className="flex items-center gap-1">
              <Eye className="h-3 w-3" />
              {views}
            </span>
          </div>
          
          <h3 className="font-semibold text-lg group-hover:text-primary transition-smooth line-clamp-2">
            {title}
          </h3>
          
          <p className="text-sm text-muted-foreground line-clamp-2">
            {excerpt}
          </p>

          {tags.length > 0 && (
            <div className="flex flex-wrap gap-2 pt-2">
              {tags.map((tag) => (
                <Badge key={tag} variant="secondary" className="text-xs">
                  {tag}
                </Badge>
              ))}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default ArticleCard;
